export default __webpack_public_path__ + "static/Community-CenteredDesigninSchoolSystems-f1b323155d9abde5754a1623177e1f08.jpg";